<template>
  <div class="bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
        <dl class="grid grid-cols-1 gap-4 gap-y-8 sm:grid-cols-2">
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">{{ __('Title') }}</dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        <input
                            class="p-1 pt-0 mt-1 text-sm block border-0 border-b border-dotted border-gray-300 focus:border-gray-500 focus:border-transparent focus:outline-none focus:ring-0 text-gray-900"
                            type="text" :placeholder="__('Title')"
                            ref="title"
                            v-model="formUpdateTitle.title"
                            @blur="updateTitle"
                            @keyup.enter="updateTitle"
                        />
                    </dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">{{ __('Plan') }}</dt>
                    <dd class="mt-1 text-sm text-gray-900">{{ __(license.package.fullName) }}</dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">{{ __('Price') }}</dt>
                    <dd class="mt-1 text-sm text-gray-900">{{ price(license.price) }}</dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">{{ __('Expires At') }}</dt>
                    <dd class="mt-1 text-sm text-gray-900">{{ date(license.expires_at) }}</dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">{{ __('License-Key') }}</dt>
                    <dd class="mt-1 text-sm text-gray-900">{{ license.license_key }}</dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">{{ __('Created At') }}</dt>
                    <dd class="mt-1 text-sm text-gray-900">{{ date(license.created_at) }}</dd>
                </div>
                <div class="sm:col-span-2">
                    <dt class="text-sm font-medium text-gray-500">{{ __('Download') }}</dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                            <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                <div class="w-0 flex-1 flex items-center">
                                    <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                    <span class="ml-2 flex-1 w-0 truncate"> {{ __('Statuspage Files') }} </span>
                                </div>
                                <div class="flex-shrink-0 space-x-2 divide-x divide-gray-200 flex">
                                  <div class="mx-auto">
                                    <button @click="copyToClipboard(route('external.download', {license: license.id}), 'Link was copied! The download is only accessible for IPs which are deposited in the Allowlist.')" class="font-medium text-gray-500 hover:text-gray-900"> {{ __('Copy Download Link') }} </button>
                                  </div>
                                  <div class="mx-auto px-2">
                                    <inertia-link :href="route('license.download', {license: license})" class="font-medium text-primary-500 hover:text-primary-600"> {{ __('Download') }} </inertia-link>
                                  </div>
                                </div>
                            </li>
                        </ul>
                    </dd>
                </div>
            </dl>
    </div>
  </div>
</template>

<script>
import { PaperClipIcon } from '@heroicons/vue/solid'
export default {
    name: "LicenseDetails",
    components: {
        PaperClipIcon,
    },
    props: ['license'],
    data() {
        return {
            formUpdateTitle: this.$inertia.form({
                title: this.license.title,
            })
        };
    },
    methods: {
        updateTitle() {
            if (this.formUpdateTitle.title !== this.license.title)
            this.formUpdateTitle.post(route('license.update', {license: this.license}))
        }
    }
}
</script>
